import {Button} from '@mantine/core';
import {AiOutlineDelete} from 'react-icons/ai';
import {ActivityEventsService} from '../services/ActivityEventsService';
import {useQueryClient} from '@tanstack/react-query';

export const ClearEventsButton = ({disabled}: { disabled?: boolean }) => {
    const queryClient = useQueryClient();

    const handleClear = async () => {
        await ActivityEventsService.clear();
        queryClient.invalidateQueries({queryKey: ['activity-events']});
    };

    return (
        <Button
            leftSection={<AiOutlineDelete/>}
            color="red"
            variant="outline"
            onClick={handleClear}
            disabled={disabled}
        >
            Clear All
        </Button>
    );
};
